import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Header = ({ headers, onSorting }) => {
    const [sortingField, setSortingField] = useState("");
    const [sortingOrder, setSortingOrder] = useState("asc");

    const onSortingChange = (field) => {
        const order =
            field === sortingField && sortingOrder === "asc" ? "desc" : "asc";

        setSortingField(field);
        setSortingOrder(order);
        onSorting(field, order);
    };

    return (
        <thead>
            <tr>
                {headers.map(({ name, field, sortable }) => (
                    <th
                        key={name}
                        onClick={() =>
                            sortable ? onSortingChange(field) : null
                        }
                    >   { sortable ?<i className="fas fa-sort"></i>:null }
                        {" "}{name}

                        {sortingField && sortingField === field && (
                            sortingOrder === "asc" ?(
                            <i className="fas fa-arrow-up"></i>
                            ):(
                            <i className="fas fa-arrow-down"></i>   
                            )
                        )}
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default Header;